import React, { PureComponent } from "react";
import { connect } from "react-redux";
import get from "lodash/get";

import { getPage } from "actions/page/page.functions";

import { SEO } from "components";

class TOS extends PureComponent {
  componentDidMount(){
    const { dispatch } = this.props;
    
    let slug = "terms-of-service";
    dispatch(getPage(slug));
  }

  render() {
    const { singlePage } = this.props;

    const seoProps = {
      SEOTitle: get(singlePage, "yoast.title"),
      SEODescription: get(singlePage, "yoast.metadesc"),
      SEOUrl: get(singlePage, "link")
    };

    return (
      <main className="view-contentpage">
        <div className="wrapper">
          <SEO {...seoProps} />
          <div className="view-contentpage__heading">
            <h1 className="u-type--beta u-type--primary">Terms of Service</h1>
          </div>
          <div className="view-contentpage__content">
            <div className="formatted--microcopy">
              <h2>Acceptance, Duration, Termination, Updates and Changes</h2>
              <p>
                <strong>1.1 Acceptance</strong>
              </p>
              <p>
                This is an agreement between SMS Provider Corp, trading as
                Viahub (&ldquo;
                <strong>Us</strong>
                &rdquo; or &lsquo;
                <strong>We</strong>
                &rdquo;), the owner and operator of{" "}
                <a href="http://www.viahub.com/">www.biondapp.com</a> (the
                &ldquo;
                <strong>Biond Website</strong>
                &rdquo;), its Affiliates, and the user (the &ldquo;
                <strong>User</strong>
                &rdquo;) of the Biond Products. By using the Biond application,
                the web platform, including the software, features, content
                within (together as &ldquo;Biond&rdquo;), the User acknowledges
                and agrees to these Terms of Service, the Biond Privacy Policy
                (available at{" "}
                <a href="http://www.biondapp.com/privacy.html">
                  http://www.biondapp.com/privacy.html
                </a>
                ), and any amendment or legal documentation which is
                incorporated herein by reference (together as the &ldquo;
                <strong>Agreement</strong>
                &rdquo;). If the User does not accept any of these terms, the
                User must not use Biond.
              </p>
              <p>
                <strong>1.2 Duration</strong>
              </p>
              <p>
                This Agreement takes effect when the User either clicks on the
                &ldquo;I accept&rdquo; button or link (or such other buttons and
                links that Biond may decide to use) for installation of Biond,
                or the date when the User first begins to use Biond, whichever
                is earlier.
              </p>
              <p>
                <strong>1.3 Termination</strong>
              </p>
              <p>
                If Viahub believes that the User has committed any of the
                following acts, Viahub reserve the right to terminate this
                Agreement at its sole discretion with immediate effect without
                notice, and/or take all necessary measures to temporarily block
                the User access to Biond and suspend the Paid User Account as
                defined below with Biond if the User has one. The acts referred
                to are where Viahub considers, at our sole discretion, that the
                User has:
              </p>
              <p>(i) breached any terms of this Agreement;</p>
              <p>
                (ii) acted contrary to or failed to follow any of our policies;
              </p>
              <p>
                (iii) infringed the intellectual property rights of Us or a
                third party;
              </p>
              <p>
                (iv) instigated or taken part in fraudulent or illegal
                activities;
              </p>
              <p>
                (v) committed any other act which has given rise to actual or
                potential legal action and/or liability; or
              </p>
              <p>
                (vi) committed any other acts of a comparable nature to those
                above.
              </p>
              <p>
                <strong>1.4 Updates and Changes</strong>
              </p>
              <p>
                We may from time to time update or change this Agreement (with
                or without giving notice to the User). The User will be able to
                view the revised Agreement on our Website. It is the
                User&rsquo;s responsibility to check our Website for such
                changes. The User agrees that even if the User should choose not
                to check for any changes to this Agreement, by continuing to use
                Biond, the User accepts and agrees to the changes and any
                revised Agreement. If the User decides that he/she does not want
                to accept the changes or revised Agreement, the User may
                uninstall Biond by deleting it from his/her device and email
                customer support at{" "}
                <a href="mailto:biond-support@viahub.eu">
                  biond-support@viahub.eu
                </a>
                to delete his/her Account.
              </p>
              <h2>Important information regarding the use of Biond Products</h2>
              <p>
                <strong>2.1 Emergency Services</strong>
              </p>
              <p>
                Under no circumstances does Viahub enable the User to make
                emergency calls to emergency services for the purpose of public
                safety pursuant to applicable laws and regulations. The User
                must arrange his/her own alternative method of contacting
                emergency services as and when it is necessary for him/her to do
                so.
              </p>
              <p>
                <strong>2.2 Jurisdiction Restrictions</strong>
              </p>
              <p>
                In the event that the law of the country where the User is
                located at any time imposes restrictions on the use of Biond for
                any reason, it is his/her responsibility to ensure he/she is
                legally allowed to use Biond.
              </p>
              <p>
                <strong>2.3 This Agreement and additional terms</strong>
              </p>
              <p>
                This Agreement and any additional terms that apply to the use of
                Biond together represent the entire Agreement between Viahub and
                the User. When the User installs Biond, the User accepts the
                Terms of Service, Biond Privacy Policy, any additional terms and
                amendments that are in force from time to time.
              </p>
              <p>
                <strong>2.4 Credit/Debit Card Information</strong>
              </p>
              <p>
                A Standard Account is an account the User creates for the use of
                free Biond, by downloading Biond and registering his/her device.
                If a person has used his/her telephone number to register a
                Standard Account with Us, then the User will have to verify
                his/her telephone number with Us through Biond&rsquo;s
                verification procedure.
              </p>
              <p>
                <strong>2.5 Export</strong>
              </p>
              <p>
                The User may not use or otherwise export or re-export Biond
                except as authorized by United States law and the laws of the
                jurisdiction in which Biond was obtained. In particular, but
                without limitation, Biond may not be exported or re-exported (a)
                into any U.S. embargoed countries or (b) to anyone on the U.S.
                Treasury Department's list of Specially Designated Nationals or
                the U.S. Department of Commerce Denied Person&rsquo;s List or
                Entity List. By using Biond, the User represents and warrants
                that the User is not located in any such country or on any such
                list. The User also agrees that he/she will not make use of
                Biond for any purposes prohibited by United States law and any
                applicable law, including, without limitation, the development,
                design, manufacture or production of nuclear, missiles, or
                chemical or biological weapons.
              </p>
              <h2> Important information about Biond</h2>
              <p>
                <strong>3.1 Factors that may affect Biond</strong>
              </p>
              <p>
                We make our best efforts to provide Biond to our users free of
                any disruptions. However, We do not warrant that Biond will
                always operate smoothly. Biond are transmitted through the
                public internet and public switched telephone network. Factors
                that are beyond Viahub&rsquo;s control;may affect the User
                experience of Biond. Such factors include but are not limited to
                security, delays and reduced quality of data transmission across
                the aforementioned networks.
              </p>
              <p>
                <strong>3.2 Objectionable Content</strong>
              </p>
              <p>
                We are committed to preventing indecent, offensive, illegal or
                otherwise objectionable Content (&ldquo;
                <strong>Objectionable Content</strong>
                &rdquo;) from being distributed via Biond either through a
                personal account or through Channel. The Content of any and all
                communications is the responsibility of the person who
                transmitted such communication(s). We will not therefore be held
                liable to any party for any exposure to Objectionable Content.
              </p>
              <p>
                <strong>3.3 Product enhancements</strong>
              </p>
              <p>
                We reserve the right to add to, remove, or update any of the
                technical and/or other features in Biond. This is to ensure that
                Biond is in line with the demands of our Biond users, so that we
                can implement any new and innovative technology, and also to
                ensure compliance with any relevant regulations that may come
                into force. The User may experience disruption to Biond during
                such time as the improvements to Biond are being implemented.
              </p>
              <p>
                <strong>3.4 SMS invitations</strong>
              </p>
              <p>
                Should the User decides to invite friends to use Biond via an
                SMS invitation, please be aware that this at his/her sole cost.
                Biond Credit cannot be used to fund the SMS invitation. This
                also applies to SMS invitations which can be made through Biond
                promotions. The User is responsible for checking any additional
                terms which may apply to such promotions.
              </p>
              <p>
                <strong>3.5 Support</strong>
              </p>
              <p>
                The User may contact Us in relation to any problems that the
                User experience in respect of Biond by emailing our support team
                at{" "}
                <a href="mailto:biond-support@viahub.net">
                  biond-support@viahub.eu
                </a>
              </p>
              <h2> The User&rsquo;s obligations</h2>
              <p>
                <strong>4.1 Information</strong>
              </p>
              <p>
                The User must allow Biond to access certain data and information
                from time to time, pursuant to our Privacy Policy at{" "}
                <a href="http://www.biondapp.com/privacy.html">
                  http://www.biondapp.com/privacy.html
                </a>
                . We will not release any of his/her information, including
                his/her telephone numbers or personal information, to the public
                without his/her consent. The User may choose to release or not
                to release any of his/her information without our interference.
                Viahub takes no responsibility for any personal information the
                User decides to release to other Biond Users. The User is
                advised to exercise extreme caution before releasing any
                personal information. Biond enables the User to block contact
                and We invite the User to use this feature if the User receive
                abuse or contact{" "}
                <a href="mailto:biond-support@viahub.net">
                  biond-support@viahub.eu
                </a>
              </p>
              <p>
                <strong>4.2 Individual use</strong>
              </p>
              <p>
                The User agrees that Biond is for individual personal use only.
                As such, using Biond for commercial use of any kind is strictly
                prohibited. The User also undertakes not to resell Biond to any
                third parties.
              </p>
              <p>
                <strong>4.3 Fraudulent use</strong>
              </p>
              <p>
                The User agrees not to use Biond to engage in fraudulent
                activities of any kind whatsoever.
              </p>
              <p>
                <strong>4.4 Permission to send Content</strong>
              </p>
              <p>
                The User undertakes to ensure that the User has the requisite
                permission, consent, authority, and approval from the intended
                recipient of any content sent through Biond, and he/she shall
                not, in absence or ignorance of such an approval, consent or
                permission, send or transmit content to the intended recipient
                using Biond.
              </p>
              <p>
                <strong>4.5 Restricted Use</strong>
              </p>
              <p>The User is not permitted to use Biond to:</p>
              <p>
                (i) share and/or submit content that is in any way whatsoever
                offensive to other users or is illegal or may give rise to
                criminal conduct and/or civil liability or is in any other way
                improper or distasteful;
              </p>
              <p>
                (ii) take any action that is intended to deliberately harm or
                negatively impact on the availability, quality or performance of
                Biond in any way whatsoever;
              </p>
              <p>
                (iii) interfere in any way whatsoever with any communication
                that the User is not the intended recipient of;
              </p>
              <p>
                (iv) gather and/or store any and all information that may be
                used to identify any individual user;
              </p>
              <p>
                (v) transmit any unwanted and/or unwelcome communications or
                content, including but not limited to spit or spam, or any other
                illegal communications or illegal content of any kind
                whatsoever;
              </p>
              <p>
                (vi) run any codes, scripts, or instructions of any kind
                whatsoever, where such codes scripts or instructions function
                and/operate so as to erase, alter, copy, dismantle or in any
                other way whatsoever cause harm to Biond;
              </p>
              <p>
                (vii) vish, phish, or pharm or attempt to vish, phish, or pharm
                for any reason or purposes whatsoever,
              </p>
              <p>
                (viii) intimidate, torment, humiliate, be a nuisance to, or
                invade the privacy of any other users or third parties;
              </p>
              <p>
                (ix) pose as or pretend to be associated with another
                individual, partnership, group, company, organization, or
                enterprise of any kind whatsoever;
              </p>
              <p>
                (x) use and/or share and/or submit any content which the User
                does not legally own or has lawful permission from the owner to
                use and/or share and/or submit; or,
              </p>
              <p>
                (xi) use any web crawlers and/or robots, web mirroring software
                or offline navigators or any other automated system of any kind
                whatsoever when logging onto or accessing Biond. We may however
                allow certain third parties to use web crawlers in order for the
                general public to search online for information created by Us
                that pertains to Biond. Such web crawlers will not however be
                permitted to cache or archive any of the said information.
              </p>
              <p>
                <strong>4.6 Responsibility for unauthorized use</strong>
              </p>
              <p>
                The User is solely responsible and liable for communications and
                actions taken (whether by the User or by a person using his/her
                Account with or without his/her permission) during and in
                respect of his/her use of Biond, including but not limited to
                calls made to premium rate numbers. In order to prevent
                unauthorized use, the User should ensure that his/her registered
                mobile phone number and password are kept confidential and the
                User should not lend his/her device(s) to any third parties.
                Unless expressly prohibited by applicable mandatory laws, the
                User agrees and acknowledges that We and/or our Affiliates,
                employees, officers or agents shall bear no liability for any
                and all possible losses of the User caused by a third party's
                communication line error, technical problem, network or mobile
                communication terminal failure, system instability and other
                force majeure events. The User hereby agrees and acknowledges
                that, notwithstanding that the User takes appropriate steps to
                minimize such risks, the likelihood of the occurrence of such
                risks cannot be excluded altogether, and the User agrees and
                acknowledges that We and our Affiliates, employees, officers or
                agents will not bear any liability for such risks, including,
                without limitation, the following:
              </p>
              <p>
                (i) other software downloaded and installed by the User
                containing viruses, such as Trojan Horse, or other malicious
                code, which threatens the security of the personal information
                and data and as a result, adversely affects the normal use of
                the Goods; or
              </p>
              <p>
                (ii) the mobile device or mobile communication terminal is
                infected by a virus or other malicious code or is damaged as a
                result of the User browsing or visiting web pages.
              </p>
              <p>
                <strong>4.7 Indemnity</strong>
              </p>
              <p>
                <strong>
                  THE USER AGREE TO INDEMNIFY, DEFEND, AND HOLD VIAHUB, ITS
                  AFFILIATES, SHAREHODLERS, OFFICERS, DIRECTORS, EMPLOYEES, AND
                  AGENTS HARMLESS FROM AND AGAINST ANY AND ALL CLAIMS, DAMAGES,
                  LIABILITIES, COSTS, AND EXPENSES (INCLUDING BUT NOT LIMITED TO
                  ANY LEGAL FEES AND COSTS WHATSOEVER AND HOWSOEVER INCURRED) IN
                  RESPECT OF ANY BREACH OR CONTRAVENTION OF THIS AGREEMENT, ANY
                  RELEVANT LAWS, RULES, OR REGULATIONS OR ANY RIGHTS OF THIRD
                  PARTIES IN CONNECTION WITH THE BIOND SOFTWARE AND PRODUCTS.
                </strong>
              </p>
              <p>
                <strong>5.Biond Goods</strong>
              </p>
              <p>
                <strong>5.1 Payment for Biond Goods</strong>
              </p>
              <p>
                The User may purchase virtual contents in the Biond Store on
                Biond, such as stickers, animation, audio effects (together as
                &ldquo;Biond
                <strong> Goods&rdquo;) </strong>
                and Biond Credits via Apple or Google Payment Corp (&ldquo;
                <strong>GPC</strong>
                &rdquo;). We may, at our sole discretion, refused his/her
                purchase by credit or debit cards from one or more card issuers,
                or payment by any other methods, with or without any notice to
                the User.
              </p>
              <p>
                <strong>5.2 Download and Usage</strong>
              </p>
              <p>
                Once the User purchased the Biond Goods, Biond will
                automatically download the purchased Biond Goods, to be used on
                Biond. The User bears the responsibility for completing the
                download and installation and for all risk of loss after
                downloading, including any loss due to any device or mobile
                communications terminal malfunction. The User is responsible for
                ensuring that his/he device(s), operating system and/or any
                other applicable software are compatible with, and supports the
                download and use of the Goods.
              </p>
              <p>
                <strong>5.3 Ownership</strong>
              </p>
              <p>
                Biond Goods are developed by Us and third party sellers. All the
                ownership, rights, title and interest of intellectual property
                rights in the Goods (including but not limited to any code,
                image and text contained in the Goods and in any and all future
                updates, modifications, revisions and/or derivative works of the
                Goods), and attached supporting documentation belong to Us and
                the relevant third party seller and may not be used, reproduced,
                altered, distributed, exploited or otherwise dealt with by the
                User without written authorization from Us, unless the said
                usage, reproduction, alteration, distribution, exploitation and
                dealing is expressly provided for in this Agreement.
              </p>
              <p>
                <strong>5.4 Refund</strong>
              </p>
              <p>
                The User may apply for a refund of the Biond Goods from Apple or
                GPC if the Goods the User purchased are misleading or faulty.
                Except as required by law and as provided for in this Clause,
                all payments are final and no returns, replacements or refunds
                are permitted. If a replacement, return or refund is granted for
                any transaction, the transaction may be reversed, and the use of
                the Goods will immediately terminate without further action by
                Us. If the User is using an Android device and the User changed
                his/her registered phone number, all purchased Biond Goods will
                be forfeited and/or deleted. If the User is using an Apple
                device and the User changed his/her registered phone number, the
                User may retrieve all purchased Biond Goods, except for Biond
                Credit, through with Apple ID.
              </p>
              <h2> Biond SMS</h2>
              <p>
                <strong>6.Biond SMS</strong>
              </p>
              <p>
                The User may send a SMS message to a non-Biond user from Biond
                Chats. One message may contain a maximum of 5 SMSs. Each SMS
                containing a maximum of 160 characters of Latin alphabets, or, a
                maximum of 70 characters of non-Latin alphabets such as Arabic
                and Chinese Alphabets. All Biond SMS sent will display the
                User&rsquo;s sender address which shall take up to 20
                characters, thereby reducing the abovementioned maximum of
                characters by 20 characters. Any SMS sent to China shall have a
                signature appended to the content which shall take up the
                abovementioned maximum characters by an additional number of
                characters.
              </p>
              <p>
                <strong>6.2 Payment for Biond SMS</strong>
              </p>
              <p>
                The User may send a SMS message to a non- Biond user through
                Biond using his/her Biond Credits. The cost of his/her Biond
                Credits depends on the country code of the recipient&rsquo;s
                mobile number. If the User&rsquo;s message exceeds the
                abovementioned character limit, it will be broken down into
                several messages for up to 5 SMSs in total and the User will be
                charged for each message he/she sent. In case of a Biond SMS is
                failed to be sent, the User will not be charged. The User will
                be able to resend the message.
              </p>
              <p>
                <strong>6.3 Usage</strong>
              </p>
              <p>
                Biond SMS available to verified Biond users only: We do not
                support group chats or multimedia contents for SMS. We do not
                guarantee the successful delivery of each of the User&rsquo;s
                SMS message, nor his/her sender address. Sender address means
                the number which will appear on the recipient&rsquo;s device.
                The User is responsible for ensuring that his/her and his/her
                recipients&rsquo; mobile device, operating system and/or any
                other applicable software are compatible with, and supports SMS
                and its related functions. Depending on his/her
                recipients&rsquo; mobile device, We do not guarantee the
                successful delivery of any emoji the User sent.
              </p>
              <p>
                <strong>7.Biond Credit</strong>
              </p>
              <p>
                <strong>7.1 Payment for </strong>
                <strong>Biond</strong>
                <strong> Credit</strong>
              </p>
              <p>
                The User is required to pay to use particular Biond features. In
                order to use such paid features, the User is required to
                maintain an adequate amount of Biond Credit in the Paid User
                Account. The User may purchase Biond Credit with his/her credit
                or debit card on Biond, or any of the methods that We make
                available from time to time, in any currency that We make
                available from time to time. We may, at our sole discretion,
                stop accepting payment by credit or debit cards from one or more
                card issuers, or payment by any other methods that We make
                available from time to time, with or without any reasons and
                with or without notice to the User. Biond Credit becomes
                inactive within 90 or 180 days (depending on the denomination
                purchased) and is subject to expiry. If the User deletes the
                Biond Paid User Account, all unused Biond Credit, as well as the
                Biond Paid User Account information, will be forfeited and/or
                deleted.
              </p>
              <p>
                <strong>7.2 Inactive Biond Credit</strong>
              </p>
              <p>
                Refers to those Biond Credit that is no longer active and is
                therefore unavailable for use until re-activated. Biond Credit
                becomes inactive within 180 days from date of purchase
                (depending on the denomination purchased). The User may
                re-activate the Biond Credit during a period of 30 (Thrity) days
                after it has become inactive by either pressing the
                &ldquo;re-activate&rdquo; button in the Paid User Account or by
                contacting customer support at{" "}
                <a href="mailto:biond-support@viahub.net">
                  biond-support@viahub.eu
                </a>
                . Inactive Biond Credit that is not re-activated shall expire.
                Inactive Credit that is re-activated shall be valid for a
                further period of 30 (Thirty) days before it expires. Biond may
                notify the User as and when his/her Biond Credit is about to
                become inactive.
              </p>
              <p>
                <strong>7.3 Expired Biond Credit</strong>
              </p>
              <p>
                Refers to those Biond Credit that cannot longer be used and are
                removed from the User&rsquo;s Biond Credit balance. Biond Credit
                expires on the date on which the period for either Inactive
                Credit (where Inactive Credit is not re-activated) or
                re-activated Biond Credit ends. For more details the User shall
                refers to our website at{" "}
                <a href="http://www.maaii.com/">http://www.biondapp.com</a>.
                Biond may notify the User as and when his/her Biond Credit is
                about to expire.
              </p>
              <p>
                <strong>7.4 Rates</strong>
              </p>
              <p>
                The User&rsquo;s Biond Credit is available for use in accordance
                with the rates stated on the Biond Website. We may change the
                applicable rates at any time. Any change to such rates will be
                published on the Biond Website. We reserve the right to publish
                such changes without any prior notice to the User. The new rates
                are applied following publication of the changes and the
                User&rsquo;s subsequent purchase of Biond Credit. The
                User&rsquo;s purchase and/or use of Biond following the changes
                of the rates constitutes his/her agreement to such changes. We
                do not provide price protection or refunds in the event of a
                price reduction or promotional offering.
              </p>
              <p>
                <strong>7.5 Billing for Biond Out Calls</strong>
              </p>
              <p>
                The Biond Credit is used up on a minute by minute basis when
                they are used for purchasing minutes. As such, any call duration
                through Biond shall be rounded up to the nearest minute and the
                relevant amount of Biond Credit shall be deducted from the
                User&rsquo;s Biond Credit balance accordingly.
              </p>
              <p>
                <strong>7.6 Mobile Operator Charges</strong>
              </p>
              <p>
                Certain communications made using and through Biond may consume
                some of the User&rsquo;s data allowance that he/she has
                purchased and/or received as part of a subscription with his/her
                mobile operator. Using Biond will incur data charges in the
                User&rsquo;s country of origin and potentially additional data
                charges when roaming onto other mobile networks internationally.
              </p>
              <p>
                <strong>7.7 Auto recharge</strong>
              </p>
              <p>
                We offer an auto-recharge for Biond Credit only. This is the
                default setting when the User first purchased Biond Credit, but
                the User may choose to change this option during his/her initial
                and subsequent purchases. For any auto-recharge payments that
                are paid and upon receiving notification of termination of
                his/her auto-recharge payment from the User, We shall take the
                last auto-recharge payment as the User&rsquo;s final payment to
                Us unless it is again initiated by the User through his/her Paid
                User Account. Should the User NOT disable the auto-recharge
                payment method; the same denomination of Biond Credit shall be
                added to his/here Biond Credit balance automatically when
                his/her Biond Credit is below USD 2.00.
              </p>
              <p>
                <strong>7.8 Tax</strong>
              </p>
              <p>
                Taxes, including but not limited to any duties, customs fees, or
                taxes (other than income tax) associated with the payment for
                the Goods, including any related penalties or interest, and any
                other government charges may be applied in the User&rsquo;s
                country of residence to the purchase of Biond Credit and Biond
                Goods. Such taxes, maybe deducted from the User&rsquo;s payment
                for the Biond Credit and Biond Goods, at our sole discretion.
                For the avoidance of doubt, taxes will only be charged in
                jurisdictions where the Goods are taxable. We will act on the
                basis that the User is not eligible for tax exemptions.
                Additional fees, such as cross border transaction fees and
                credit card fees, may apply.
              </p>
              <p>
                <strong>7.9 Free Promotional Credit</strong>
              </p>
              <p>
                From time to time We may offer Users free credit to make calls
                to the PSTN. The User is not permitted to resell such
                promotional Biond Credit to any third parties. Any such
                reselling or similar behaviour shall entitle Us to immediately
                terminate this Agreement. The User may use free promotional
                Biond Credit provided that he/she has verified his/her telephone
                number by following our verification procedure. Free promotional
                Biond Credit allocations will expire within 180 days. The User
                may re-activate promotional Biond Credit during a period of 30
                days after it has become inactive by setting up a Paid User
                Account. Inactive promotional Biond Credit that is not
                re-activated shall expire. Inactive promotional Biond Credit
                that is re-activated shall be valid for a further period of 30
                days before it expires. We may notify the User as and when
                his/her Biond Credit is about to become inactive or expire. If
                the User chooses to de-activate Biond and subsequently
                re-activate it, the User will not be entitled to receive any
                Promotional Credit. For any current or future free promotions.
                additional terms may apply to such free promotions. The User is
                responsible for checking the additional terms that may apply to
                such promotions.
              </p>
              <p>
                <strong>7.10 Incorrect Charging</strong>
              </p>
              <p>
                If the User considers that We have charged him/her incorrectly,
                the User must contact our customer service by email at{" "}
                <a href="mailto:biond-support@viahub.eu">
                  biond-support@viahub.eu
                </a>{" "}
                within 30 days after the alleged incorrect charging. No dispute
                will be investigated and/or resolved if the User has not
                contacted Us within the said period.
              </p>
              <p>
                <strong>7.11 Refund Policy</strong>
              </p>
              <p>
                The User may request a refund for any Biond Credit that is
                purchased from{" "}
                <a href="http://www.biondapp.com/">www.biondapp.com</a> and
                remains completely unused within 7 days of such purchase. It is
                our discretion to give such a refund. A handling fee may be
                applied to the approved refunds. For the avoidance of doubt,
                Biond Credit that has expired is non-refundable. In order to
                make a refund request of the Biond Credits, the User should
                submit a request to customer support by email to{" "}
                <a href="mailto:biond-support@viahub.eu">
                  biond-support@viahub.eu
                </a>
                . Viahub reserves the right to refuse persistent refund requests
                and terminate this Agreement with immediate effect,
                automatically and without recourse to the courts, in the event
                of any abuse by the User of our refund policy.
              </p>
              <h2> License</h2>
              <p>
                <strong>8.1 License terms</strong>
              </p>
              <p>
                On the condition that the User agrees to, accepts and complies
                with this Agreement, We grant the User a free and non-exclusive
                non-transferable license to install Biond on his/her device. The
                User is not permitted to assign or sub-license the license
                granted to him/her to any person or third parties. The
                User&rsquo;s license allows the User to use Biond either from
                his/her device or from Biond Web platform. All other rights not
                granted in this Agreement are reserved by Us.
              </p>
              <p>
                <strong>8.2 Restricted use</strong>
              </p>
              <p>
                The User agrees that, in addition to the conditions mentioned
                above in respect of the license granted to the User by Us, the
                User will not, in respect of such license, sell, distribute,
                reproduce, rent, lease, license or reverse engineer, dissemble
                or decompile Biond and Biond Goods, including any features,
                content and/or Goods contained therein, or try by any other
                methods to reveal the source code or modify Biond in any other
                way whatsoever.
              </p>
              <p>
                <strong>8.3 Misuse</strong>
              </p>
              <p>
                If the User uses, or We believe or consider that the User has
                used Biond for any of the prohibited acts and the like as stated
                in the Agreement, We may, at our sole discretion, immediately
                terminate the User&rsquo;s license to use Biond and Biond Goods,
                suspend or terminate his/her account and/or subscription,
                restrict his/her use of Biond and Biond Goods in part or in
                whole, at our sole and absolute discretion, without notice and
                without any refund to the User.
              </p>
              <p>
                <strong>8.4 Separate license agreements</strong>
              </p>
              <p>
                The User agrees that when he/she uses Biond which has been
                pre-installed, packaged with or comes as a part of any other
                products or services of any kind (whether electronic or
                otherwise) (&ldquo;
                <strong>Third Party Technology&rdquo;) </strong>
                it may be necessary for the User to agree to and/or accept a
                third party license agreement in order to obtain a license to
                use the Third Party Technology. The User also accepts that the
                use of such Third Party Technology may impact on the
                availability and/or use Biond.
              </p>
              <h2> Proprietary Rights</h2>
              <p>
                <strong>9.1 </strong>
                Parts of Biond, its Website, Software and Goods are comprised of
                information of a proprietary and/or confidential nature that is
                afforded protection under intellectual property law. We hold the
                sole and exclusive intellectual property and all other rights
                and ownership in Biond (regardless of whether such rights are
                registered). The User agrees not to take any legal or other
                actions that may affect the proprietary and intellectual
                property rights of Us in Biond in any way whatsoever.
              </p>
              <p>
                <strong>9.2 </strong>
                The content in Biond, including but not limited to audio, audio
                clips, text, images, icons, graphics, logos, text, virtual
                goods, and digital downloads (including wallpapers
                <strong>)&nbsp;</strong>
                is owned by Us and afforded protection under copyright and
                trademarks laws. The User is therefore expressly prohibited from
                reproducing the content, unless the User has first obtained
                permission to do so from Us. Any unauthorized acts, including
                but not limited to reproduction, may result in Us taking
                criminal and/or civil legal action against the User. All other
                rights in Biond are expressly reserved.
              </p>
              <p>
                <strong>9.3 </strong>
                We have registered and filed applications to register the
                trademark &ldquo;Viahub&rdquo; and other related trademarks and
                logos in various jurisdictions worldwide. It is not permitted
                and the User agrees not to register and/or use such trademarks
                and/or trade dress or any other intellectual property (or any
                part thereof) that belongs to Us, Biond, in any way whatsoever
                for any or no reason, or any other marks or logos that are so
                similar in nature so as to cause confusion to other persons,
                entities, or third parties. Any third party trademarks that do
                not belong to Us that may be used or are displayed on Biond are
                owned by such third parties.
              </p>
              <h2>
                Viahub&rsquo;s limitation of liability under this Agreement
              </h2>
              <p>
                <strong>10.1 </strong>
                We, our affiliates, officers, directors, licensors, employees,
                agents or employees shall not be held be liable, in contract,
                tort or any other relevant legal principles, for any special,
                indirect, incidental exemplary or consequential damages
                (including but not limited to liability for lost profits,
                business, or income), and irrespective of whether Viahub, its
                affiliates, officers, directors, licensors, employees, agents or
                employees have been warned of the possibility of such losses or
                damages arising.
              </p>
              <p>
                <strong>10.2 </strong>
                None of the terms in this Agreement operate or shall be
                construed to operate so as to limit or exclude our liability for
                death or personal injury cause by our negligence or the
                negligence of our affiliates, officers, directors, licensors,
                agents or employees, or any other liability which may not be
                limited or excluded by operation of applicable law.
              </p>
              <p>
                <strong>10.3 I</strong>n any event, our total liability in
                contract, tort or any other relevant legal principles under in
                respect of or under this Agreement shall be limited to the
                amount paid by any given User up to a maximum of 100 US Dollars.
                This limitation of liability shall not apply if the claim for
                loss is in respect of willful default or gross negligence.
              </p>
              <p>
                <strong>10.4 </strong>
                Our company, its affiliates, officers, directors, licensors,
                agents or employees shall not be held be liable, in contract,
                tort or any other relevant legal principles, for any claim
                (whether for loss, damage or otherwise) arising out of or in
                connection with the User being unable to contact any emergency
                services when using Biond.
              </p>
              <p>
                <strong>10.5 </strong>
                Our company, its affiliates, officers, directors, licensors,
                employees, agents or employees shall not be held be liable in
                contract, tort or any other relevant legal principles, for any
                claim (whether for loss, damage or otherwise) arising out of or
                in connection with any content on Biond.
              </p>
              <p>
                <strong>10.6 </strong>
                Where the jurisdiction in which the User is located does not
                permit all of the limitations and exclusions of liability as set
                out in this title 10, then any liability arising under such
                circumstances shall be limited or excluded as far as the law of
                that jurisdiction allows under the relevant legislation.
              </p>
              <p>
                <strong>10.7 </strong>
                We will not be deemed to have breached this Agreement to the
                extent that performance of its obligations or attempts to cure
                any breach are delayed or prevented by reason of any act of God,
                fire, natural disaster, accident, act of government, act of war
                or terrorism, shortage of materials or supplies beyond the
                reasonable control of Viahub, strike, labor dispute or walkout,
                or any other cause beyond the reasonable control of Viahub, (a
                &ldquo;
                <strong>Force Majeure Event</strong>
                &rdquo;); Viahub will try to inform the User of the nature and
                duration of the Force Majeure Event. Our company, its
                affiliates, officers, directors, licensors, employees, agents or
                employees shall not be held to be liable in contract, tort or
                any other relevant legal principles, for any claim (whether for
                loss, damage or otherwise) arising out of or in connection with
                any failure on our part to perform its obligations under this
                Agreement where such failure is as a result of a Force Majeure
                Event.
              </p>
              <h2> No Warranties</h2>
              <p>
                <strong>11.1 </strong>
                EXCEPT AS EXPRESSLY SET FORTH HEREIN, AND TO THE MAXIMUM EXTENT
                PERMITTED BY APPLICABLE LAW, BIOND AND BIOND GOODS ARE PROVIDED
                ON AN &ldquo;AS IS&rdquo; BASIS, AND WE EXPRESSLY DISCLAIM ALL
                WARRANTIES OF ANY KIND, WHETHER EXPRESS, IMPLIED OR STATUTORY,
                INCLUDING, WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF
                PERFORMANCE, SATISFACTORY QUALITY, MERCHANTABILITY, FITNESS FOR
                PARTICULAR USE OR PURPOSE, OR NON-INFRINGEMENT OF THIRD PARTY
                RIGHTS. WE DO NOT WARRANT OR GUARANTEE CONTINUOUS OR
                UNINTERRUPTED SERVICE. WE DO NOT WARRANT THAT THE SERVICES WILL
                BE SECURE, ERROR-FREE, OR THAT DEFECTS IN THE SERVICES WILL BE
                CORRECTED. NO ORAL OR WRITTEN INFORMATION OR ADVICE GIVEN BY US
                WILL CREATE A WARRANTY.
              </p>
              <h2> Update Announcements</h2>
              <p>
                <strong>12.1 General</strong>
              </p>
              <p>
                We allow our Users to submit User updates and other
                communications and/or content ("
                <strong>Update Announcements</strong>
                ") which may be shared with other Users. The ownership rights of
                the Update Announcements are retained by the User, subject to
                the terms set out in this title. Any Update Announcements
                submitted and/or shared by the User are not treated as
                confidential by Us under any circumstances. For the User&rsquo;s
                personal safety, the User is reminded to be careful about who
                the User shares his/her location and/or any other content with
                through Update Announcements or otherwise through Biond.
              </p>
              <p>
                <strong>
                  12.2 Legal responsibility for Update Announcements
                </strong>
              </p>
              <p>
                The User bears all responsibility for his/her Update
                Announcements when the User shares and/or submits them. We act
                as a passive conduit only in storing and distributing such data.
                Any views or opinions expressed in such Update Announcements do
                not therefore necessarily correspond to the views or opinions of
                Us. We do not endorse and take no responsibility and accept no
                liability for the legitimacy (legal or otherwise) of such Update
                Announcements, or for any shock or distress caused by content
                which the User has viewed
                <strong>. </strong>
                The User warrants that:
              </p>
              <p>
                (i) He/she owns or has obtained all the relevant legal rights
                and/or authority and therefore he/she is legally entitled to
                authorize Us to publish and/or use his/her Update Announcements
                for the provision of Biond Goods and/or services to the User and
                other Users, and;
              </p>
              <p>
                (ii) He/she owns or has obtained all the relevant legal rights
                and/or authority from any person where the User has identified
                himself/herself by name or a name similar to his/her or by
                telephone number, and therefore the User is legally entitled to
                authorize Us to publish and/or use his/her Update Announcements
                for the provision of Biond Goods and/or services to the User and
                other Users.
              </p>
              <p>
                <strong>12.3 License of the Update Announcements</strong>
              </p>
              <p>
                When the User submits and/or shares his/her Update Announcements
                to Us, the User agrees to grant Us for an indefinite duration a
                transferable, royalty-free, non-exclusive, worldwide license to
                use, distribute, sub-license, create alternative works of and
                display the Update Announcements for the provision of and in
                connection with Us. For the avoidance of doubt, such rights
                include but are not limited to use for the marketing and
                promoting Biond in any form and through any format or platform
                that we may choose to use from time to time. The foregoing
                license granted by the User may terminate once the User removes
                or deletes a User Status Announcement from us.
              </p>
              <p>
                <strong>
                  12.4 License of the Update Announcements to other users
                </strong>
              </p>
              <p>
                When the User submits and/or shares his/her Update Announcements
                to Us, he/she also agrees to grant every User that follows
                his/her Update Announcements through their device (whether
                displayed on Biond) a non-exclusive license to access such
                Update Announcements. The foregoing license granted by the User
                terminates once the User removes or deletes a User Status
                Announcement from Biond.
              </p>
              <p>
                <strong>
                  12.5 The User&rsquo;s representations and warranties relating
                  to Update Announcements
                </strong>
              </p>
              <p>
                The User represents and warrants that in respect of her/his
                Update Announcements, he/she will not:
              </p>
              <p>
                (i) share and/or submit any content which the User does not
                legally own or has lawful permission from the owner to share
                and/or submit and as such grant Us and other Users the licenses
                as set out in this Agreement;
              </p>
              <p>
                (ii) share and/or submit untruthful, misleading or malicious
                content which may cause harm or damage to Us or third parties;
              </p>
              <p>
                (iii) share and/or submit content that is in any way whatsoever
                offensive to other Users or is illegal or may give rise to
                criminal conduct and/or civil liability or is in any other way
                improper or distasteful;
              </p>
              <p>
                (iv) attempt to solicit or induce other Users (as customers or
                otherwise) to take part in any of his/her own commercial
                activities;
              </p>
              <p>(v) pose as another User or person for any or no reason;</p>
              <p>
                (vi) share and/or submit or otherwise attempt to transmit or
                store any malware of any kind whatsoever;
              </p>
              <p>
                (vii) take any action that is intended to deliberately harm or
                negatively impact on the quality or performance of the Biond
                Goods in any way whatsoever, and;
              </p>
              <p>
                (viii) try to gain access to Biond without the permission or
                consent of Us.
              </p>
              <p>
                <strong>12.6 Personal use</strong>
              </p>
              <p>
                We allow the User to share and/or submit content in his/her
                Update Announcements of a personal nature only. The User is
                strictly prohibited from posting content on his/her Update
                Announcements that are for commercial purposes of any kind.
              </p>
              <p>
                <strong>
                  12.7 Removal of content in respect of Update Announcements
                </strong>
              </p>
              <p>
                We reserve the right to remove any and all content and/or Update
                Announcements submitted and/or shared at our sole discretion and
                with or without notice to the User and for any or no reason.
                Content and/or Update Announcements may be removed if it:
              </p>
              <p>(i) violates in any way this Agreement;</p>
              <p>
                (ii) infringes the intellectual property rights of third
                parties;
              </p>
              <p>
                (iii) is of an adult nature and is submitted and/or shared
                without any warning to other Users; or,
              </p>
              <p>(iv) is excessive in length.</p>
              <p>
                <strong>
                  12.8 Breaches in respect of Update Announcements
                </strong>
              </p>
              <p>
                In relation to the acts described in 12.7 above and the
                performance of such acts, We reserve the right to terminate,
                restrict, and/or limit the User access to Biond.
              </p>
              <h2> Miscellaneous</h2>
              <p>
                <strong>13.1 Entire Agreement</strong>
              </p>
              <p>
                This Agreement constitutes the entire agreement between Us and
                the User concerning its subject matter and supersedes any and
                all prior or contemporaneous, written or oral negotiations,
                correspondence, understandings and agreements in any form in
                respect of the subject matter. Nothing in this clause shall
                exclude or restrict the liability of either party arising out of
                fraud or fraudulent misrepresentation.
              </p>
              <p>
                <strong>13.2 Severability</strong>
              </p>
              <p>
                If any provision or portion thereof of this Agreement is
                determined by a court of competent jurisdiction, or declared
                under any law, rule or regulation of any government having
                jurisdiction over the parties hereto, to be invalid, illegal or
                otherwise unenforceable, then such provision will, to the extent
                permitted be construed to give effect to its intent to the
                maximum extent permissible under the applicable law and the
                remainder of this Agreement will remain in full force and
                effect.
              </p>
              <p>
                <strong>13.3 Waiver</strong>
              </p>
              <p>
                Any delay or failure by Us in taking any action in relation to
                any and all rights it has under this Agreement will not operate
                as a waiver of such rights, or no waiver of any provision or
                consent to any action by Us will constitute a waiver of any
                other provision or consent to any other action, whether or not
                they are similar. No waiver or consent will constitute a
                continuing waiver or consent or commit Biond to provide a waiver
                in the future.
              </p>
              <p>
                <strong>13.4 Assignment</strong>
              </p>
              <p>
                The User is expressly prohibited from assigning this Agreement
                or any rights granted to the User here under to any thirdparty.
                We reserve the right to assign this Agreement and/or any rights
                held by Us hereunder with or without notice to any third party
                of its choosing
              </p>
              <p>
                <strong>13.5 Choice of Law</strong>
              </p>
              <p>
                This Agreement shall be governed by and construed in accordance
                with the laws of United States of America and shall be subject
                to the exclusive jurisdiction of the courts of United States of
                America.
              </p>
              <p>
                <strong>13.6 Language</strong>
              </p>
              <p>
                The English version of this Agreement may be translated into
                other languages. In the event that any inconsistency or
                discrepancy exists between the English version and a version in
                another language, the version in the English language shall
                prevail.
              </p>
              <p>
                <strong>13.7 Survival</strong>
              </p>
              <p>
                Title 4.7, 8.2, 9, 10, 11 and 13 shall survive any termination
                of this Agreement, as shall any Additional and other terms which
                are expressed so as to survive should this Agreement be
                terminated.
              </p>
              <p>
                <strong>
                  WHEN THE USER CLICKS ON THE &ldquo;I ACCEPT&rdquo; BUTTON OR
                  LINK (OR SUCH OTHER BUTTONS OR LINKS THAT WE MAY DECIDE TO
                  USE) AND/OR BY USING BIOND THE USER CONFIRMS THAT HE/SHE HAS
                  READ AND AGREES TO THIS AGREEMENT AND UNDERSTAND EACH AND
                  EVERY TERM STATED HEREIN AND GRANT US ALL THE RIGHTS AS SET
                  OUT IN THIS AGREEMENT.
                </strong>
              </p>
            </div>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => {
  const { singlePage } = state.pages;

  return {
    singlePage
  };
};

export default connect(mapStateToProps)(TOS);



// WEBPACK FOOTER //
// ./src/views/TOS.jsx